module.exports = __webpack_public_path__ + "img/celer-light.12093b14.svg";